// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__XrTBL","colBig":"styles_colBig__28ep2","colSmall":"styles_colSmall__1gdio"};